/* eslint-disable react/prop-types */
// components/layout/BasicLayout.jsx
import React from 'react'
import { AppProvider } from '@toolpad/core/AppProvider'
import { Box } from '@mui/material'
import { unauthenticatedTheme } from '../theme'

const BasicLayout = ({ children }) => {
  return (
    <AppProvider
      theme={unauthenticatedTheme}
      branding={{
        logo: <img
          src="/favicon.ico"
          alt="Mermaid Portal logo"
          style={{
            transform: 'scale(0.8)',
            transformOrigin: 'center'
          }}
        />,
        title: 'Mermaid Portal'
      }}
    >
      <Box
        sx={{
          // 100vh alone is wrong on mobile browsers: it measures the viewport
          // with the URL bar hidden, so the page is always a little taller than
          // the screen. `dvh` tracks the bar as it collapses.
          //
          // Not written as `['100vh', '100dvh']`: an array in `sx` is a
          // per-breakpoint list, not a CSS fallback chain, so that form would
          // apply `100dvh` only from the second breakpoint (480px) upwards -
          // missing every phone in portrait, which is the case it exists for.
          minHeight: '100vh',
          '@supports (min-height: 100dvh)': {
            minHeight: '100dvh'
          },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          background: '#f0f2f5',
          // Full-bleed on a phone; the login card supplies its own padding.
          padding: { xs: 1, sm: 2 },
          // Respect the notch and the home indicator on iOS.
          paddingTop: 'max(8px, env(safe-area-inset-top))',
          paddingBottom: 'max(8px, env(safe-area-inset-bottom))'
        }}
      >
        {children}
      </Box>
    </AppProvider>
  )
}

export default BasicLayout
